// extracted by mini-css-extract-plugin
var _1 = "rppn8IFuS7EMk7J8CT1r";
var _2 = "e0ynwdLwFiFG2oWTum6p";
var _3 = "LIQIuh4nfnifL3UG4Gf0";
export { _1 as "details", _2 as "name", _3 as "root" }
